import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  queueCallData: {},
  error: null,
  loading: false,
};

const queueCallsStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const queueCallsSuccess = (state, action) => {
  return updateObject(state, {
    queueCallData: action.queueCallData,
    loading: false,
  });
};

const queueCallsFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QUEUE_CALLS_START:
      return queueCallsStart(state, action);
    case actionTypes.QUEUE_CALLS_SUCCESS:
      return queueCallsSuccess(state, action);
    case actionTypes.QUEUE_CALLS_FAIL:
      return queueCallsFail(state, action);
    default:
      return state;
  }
};

export default reducer;
